import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (window.location.search) {
  sessionStorage.setItem('pre_boot_query_params', window.location.search);
}
if (environment.production) {
  enableProdMode();
  console.log = function(){};
} else if(!environment.production) {
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
